export const environment = {
  production: true,
  clientId: window["env"]["clientId"],
  clientSecret: window["env"]["clientSecret"],
  defaultLang: window["env"]["defaultLang"] || 'de',
  backendApiUrl: window["env"]["backendApiUrl"]
};
